'use strict';

angular.module('shiftTraderApp')
  .directive('saEmployeeWeekGrid', ['$compile', '$timeout', 'TimeService', function ($compile, $timeout, TimeService) {


    return {
      restrict: 'EA',
      templateUrl: 'views/directives/saEmployeeWeekGrid.html',
      scope: {
        user: '=',
        workPeriods: '=',
        weekRange: '=',
        adjustedWeekRange: '=',
        eventSuffix: '@'
      },
      link: function postLink(scope, element) {
        var createTimeText = function(rule) {
          var startTimeHTML = TimeService.minutesToTimeString(rule.start_time_minutes, true);
          var endTimeHTML = TimeService.minutesToTimeString(rule.end_time_minutes, true);

          return startTimeHTML + '-' + endTimeHTML;
        };

        var initCalendarDates = function() {
          scope.calendarDates = _.map(_.range(7), function(dayNum) {
            return moment(scope.weekRange.start).add(dayNum, 'days').twix(moment(scope.weekRange.start).add(dayNum + 1, 'days'))
          });
        };

        var initializeWeekCalendarData = function() {
          scope.workPeriodsByDay = _.map(_.range(7), function(dayNum) {
            return {
              dt: scope.calendarDates[dayNum],
              adt: moment(scope.adjustedWeekRange.start).add(dayNum, 'days').twix(moment(scope.adjustedWeekRange.start).add(dayNum + 1, 'days')),
              label: moment(scope.weekRange.start).add(dayNum, 'days').format('ddd'),
              workPeriods: [],
              unavailabilityItems: [],
              numHours: 0
            };
          });
        };

        var sortAndAssignWorkPeriods = function() {
          _.each(scope.workPeriods, function(wp) {
            if (wp.user.id === scope.user.id) {
              _.each(scope.workPeriodsByDay, function(day) {
                if (day.dt.contains(wp.start_time)) {
                  wp._formattedDate = wp.start_time.format('h:mma').slice(0, -1) + '-' + wp.end_time.format('h:mma').slice(0, -1);
                  day.workPeriods.push(wp);

                }
                // add hours to that day corresponding to the adjusted time
                var intersectionLength = Math.abs(wp.range_twix.intersection(day.adt).length('minutes'));
                if (wp.range_twix.overlaps(day.adt) && intersectionLength > 0) {
                  day.numHours += (intersectionLength / 60.0);
                }
              });
            }
          });
        };

        var initUnavailabilityItems = function(dayIndex) {
          // dayIndex is 0..6 corresponding to array of dates being passed in (scope.calendarDates)
          // look through time_off_rules for a day off here

          // add hours to startDayOfWeek calculation to ensure no TZ/DST issues
          var conditions = {
            startDayOfWeek: moment(scope.calendarDates[dayIndex].start).add(6, 'hours').day(),
            twix: scope.calendarDates[dayIndex]
          };

          var theTwix = moment(conditions.twix.start).twix(moment(conditions.twix.end));

          var timeOffRules = _.where(scope.user.time_off_rules, function(rule) {
            return rule.range_twix.overlaps(theTwix) && rule.active && rule.$isApproved();
          });

          if (timeOffRules.length > 0) {
            _.each(timeOffRules, function(rule) {
              var intersection = rule.range_twix.intersection(conditions.twix);
              var isAllDay = intersection.equals(scope.calendarDates[dayIndex]);

              // index of workPeriodsByDay is the modified index (Monday may be in 0th position)
              scope.workPeriodsByDay[dayIndex].unavailabilityItems.push({
                id: rule.id,
                reason: rule.comment !== '' ? rule.comment : 'No reason provided',
                text: isAllDay ? 'All Day' : TimeService.minimalTwixFormat(intersection, true),
                classes: {
                  dayoff: true,
                  weekly: false,
                  allday: isAllDay
                }
              });
            });
          }

          var relevantSet = _.find(scope.user.availability_sets, function(availSet) {
            // add 6 hours just in case availabilitySet is changing on dayStartHour (up to 6)
            return availSet.$isInEffect(moment(conditions.twix.start).add(6, 'hours')) && availSet.$isApproved();
          });

          if (relevantSet) {
            var realDayIndex = scope.dayOfWeekMapping[dayIndex];
            var unavailableRules = _.where(relevantSet.availability_rules, {day_of_week: realDayIndex, avail: false});
            _.each(unavailableRules, function(rule) {
              var isAllDay = rule.start_time_minutes === 0 && rule.end_time_minutes === 1440;
              scope.workPeriodsByDay[dayIndex].unavailabilityItems.push({
                id: rule.id,
                reason: rule.messages && !_.isUndefined(_.last(rule.messages)) ? _.last(rule.messages).text : 'No reason provided',
                text: isAllDay ? 'All Day' : createTimeText(rule),
                classes: {
                  dayoff: false,
                  weekly: true,
                  allday: isAllDay
                }
              });
            });
          }
        };


        var render = function () {
          initCalendarDates();
          initializeWeekCalendarData();
          sortAndAssignWorkPeriods();

          _.each(_.range(7), function(dayIndex) {
            initUnavailabilityItems(dayIndex);
          })
        };

        // Create mapping for typical dayOfWeek mapping Sunday=0..Saturday=6 to their store's map
        scope.dayOfWeekMapping = {};
        var tempDayIndex = scope.adjustedWeekRange.start.day();
        _.each(_.range(7), function(dayNum) {
          scope.dayOfWeekMapping[dayNum] = tempDayIndex;
          if (tempDayIndex === 6) {
            tempDayIndex = 0;
          } else {
            tempDayIndex = tempDayIndex + 1;
          }
        });

        render();

        var eventSuffix = !_.isUndefined(scope.eventSuffix) ? scope.eventSuffix : '';
        scope.$on('sa:saEmployeeWeekGrid:' + eventSuffix, function(event, data) {
          if (data.userId === scope.user.id) {
            console.log('sa:saEmployeeWeekGrid:' + eventSuffix, data.userId);
            render();
          }
        });
      }
    }
  }]);
